import { render, staticRenderFns } from "./ProcesoPago.vue?vue&type=template&id=1b25a77e&"
import script from "./ProcesoPago.vue?vue&type=script&lang=ts&"
export * from "./ProcesoPago.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports